const gTagEventListener = () => {
	document.querySelector( 'a[href^="tel"]' ).addEventListener( 'click', function ( e ) {
		let name = this.getAttribute( 'data-name' ) ||  'Not Set';
		gtag( 'event', e.type, {
			event_category: name,
			event_label: document.querySelector( 'title' ).innerText,
		} );
	} );
}

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', gTagEventListener );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	gTagEventListener();
}


const createOverlay = () => {
	// if there's no overlay, create one
	// it will be hidden via style.display = none by default
	if ( ! document.querySelector( '.overlay' ) ) {
		// create an overlay positioned under the navRow, pass `0` as navRowHeight to place at the top of the window
		const overlay = document.createElement( 'div' );
		overlay.classList.add( 'overlay' );
		document.querySelector( 'body' ).appendChild( overlay );
	}

	return document.querySelector( '.overlay' );
}

const getOverlay = () => {
	if ( ! document.querySelector( '.overlay' ) ) {
		return createOverlay();
	} else {
		return document.querySelector( '.overlay' );
	}
}

function handleExternalLinks() {
	const currentHost = window.location.host;
	document.querySelectorAll( `a:not([href*="${currentHost}"]):not([href^="tel:"]):not([href^="mailto:"]):not([href^="#"]):not([href^="/"])` ).forEach( ( a ) => {
		a.setAttribute( 'target', '_blank' );
		a.setAttribute( 'rel', 'noopener noreferrer' );
	} );
}

function handleJumpLinks() {
	document.querySelectorAll( '.rmg-toc a[href^="#"], a[href="#contact-information"]' ).forEach( ( a ) => {
		a.addEventListener( 'click', function ( event ) {
			event.preventDefault();
			this.blur();
			const target = document.querySelector( this.getAttribute( 'href' ) );
			if ( target ) {
				const headerHeight = document.querySelector('header').offsetHeight;
				const topOfMyDestination = target.offsetTop - headerHeight;
				window.scroll({ top: topOfMyDestination, behavior: "smooth" });
			}
		} );
	} );
}

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', handleExternalLinks );
	document.addEventListener( 'DOMContentLoaded', handleJumpLinks );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	handleExternalLinks();
	handleJumpLinks();
}


const handleReadMoreButtons = () => {
	const locationDetailsWrappers = document.querySelectorAll( '.rmg-block-rmg-location-details-wrapper' );

	locationDetailsWrappers.forEach( cards => {
		const paragraphs = cards.querySelectorAll( '.location-details-content p' );
		paragraphs.forEach( paragraph => {
			if ( paragraph.offsetHeight > 120 ) {
				cards.classList.add( 'long' );
			}
		} );

		const buttons = cards.querySelectorAll( '.btn' );
		buttons.forEach( button => {
			button.addEventListener( 'click', () => {
				cards.classList.toggle( 'open' );
				buttons.forEach( buttonQueriedFromButton => {
					buttonQueriedFromButton.classList.toggle( 'open' );
					buttonQueriedFromButton.innerHTML = buttonQueriedFromButton.innerHTML === 'Read More' ? 'Read Less' : 'Read More';
				} );
			} );
		} )
	} );
}

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', handleReadMoreButtons );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	handleReadMoreButtons();
}

function isDescendant( parent, child ) {
	let node = child.parentNode;
	while ( node != null ) {
		if ( node == parent ) {
			return true;
		}
		node = node.parentNode;
	}
	return false;
}

function isParent( element, object ) {
	let node = element.parentNode;
	while ( node != null ) {
		if ( node == object ) {
			return true;
		}
		node = node.parentNode;
	}
	return false;
}

const handleMainNav = () => {
	const subMenus = document.querySelectorAll( '.nav-main .sub-menu' );
	subMenus.forEach( ( subMenu ) => {
		subMenu.classList.add( 'hidden' );
	} );

	const subNavLinkContainers = document.querySelectorAll( '.nav-main .menu-item-has-children' );
	subNavLinkContainers.forEach( ( subNavLinkContainer ) => {
		const subMenu = subNavLinkContainer.querySelector( '.sub-menu' );
		subNavLinkContainer.removeChild( subMenu );

		const subMenuWrapper = document.createElement( 'div' );
		subMenuWrapper.classList.add( 'sub-menu-wrapper', 'hidden' );
		subNavLinkContainer.appendChild( subMenuWrapper );

		const subMenuContainer = document.createElement( 'div' );
		subMenuContainer.classList.add( 'container' );
		subMenuWrapper.appendChild( subMenuContainer );

		const subMenuRow = document.createElement( 'div' );
		subMenuRow.classList.add( 'row' );
		subMenuContainer.appendChild( subMenuRow );

		const subMenuCol = document.createElement( 'div' );
		subMenuCol.classList.add( 'col' );
		subMenuRow.appendChild( subMenuCol );

		const menuTVScreenImg = document.createElement( 'div' );
		menuTVScreenImg.classList.add( 'img' );
		subMenuCol.appendChild( menuTVScreenImg );

		subMenuCol.appendChild( subMenu );

	} );

	subNavLinkContainers.forEach( ( subNavLinkContainer ) => {
		subNavLinkContainer.querySelector( 'a' ).addEventListener( 'mouseenter', window.openSubNavTray = function ( e ) {
			e.preventDefault();
			this.classList.toggle( 'open' );
			subNavLinkContainer.querySelector( '.sub-menu' ).classList.toggle( 'hidden' );
			subNavLinkContainer.querySelector( '.sub-menu-wrapper' ).classList.toggle( 'hidden' );
			document.addEventListener( 'mouseover', window.closeSubNavTray = function ( event ) {
				const hoveredElement = event.target;
				let subMenuWrapper = e.target.parentElement.querySelector( '.sub-menu-wrapper' );
				if ( ! isDescendant( subMenuWrapper, hoveredElement ) && hoveredElement != subMenuWrapper && ! isParent( e.target, hoveredElement ) ) {
					e.target.classList.remove( 'open' );
					subNavLinkContainer.querySelector( '.sub-menu' ).classList.add( 'hidden' );
					subNavLinkContainer.querySelector( '.sub-menu-wrapper' ).classList.add( 'hidden' );
				}
			} );
		} );
	} );
}

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', handleMainNav );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	handleMainNav();
}


const handleMobileNav = () => {
	const triggerNavMobile = document.querySelector( '.trigger-nav-mobile' );
	const navMobile = document.querySelector( '.nav-mobile' );
	// create an overlay
	const overlay = createOverlay();

	const closeMobileNav = () => {
		triggerNavMobile.classList.remove( 'open' );
		navMobile.classList.remove( 'open' );
		document.body.classList.remove( 'nav-mobile-active' );
		document.querySelector( '.nav-mobile .sub-menu' ).classList.remove( 'shown' );
		overlay.style.display = 'none';
		overlay.removeEventListener( 'click', closeMobileNav );
	}


	if ( triggerNavMobile && navMobile ) {
		triggerNavMobile.addEventListener( 'click', () => {
			if ( navMobile.classList.contains( 'open' ) ) {
				closeMobileNav( triggerNavMobile, navMobile, overlay );
			} else {
				// if the sidebar nav is present and open, close it
				// this removes the event handler on the overlay from that
				if ( document.querySelector( '.sidebar-nav-contents-wrapper' ) && ! document.querySelector( '.sidebar-nav-contents-wrapper' ).classList.contains( 'closed' ) ) {
					const sidebarNavContentsWrapper = document.querySelector( '.sidebar-nav-contents-wrapper' );
					const sidebarNavToggle = document.querySelector( '.sidebar-nav-toggle' );
					toggleSidebarNav( sidebarNavContentsWrapper, sidebarNavToggle, overlay );
				}

				// give it a close button
				const mobileNavCloseButton = document.createElement( 'button' );
				mobileNavCloseButton.classList.add( 'nav-close-button' );
				mobileNavCloseButton.innerText = 'Close';
				mobileNavCloseButton.addEventListener( 'click', closeMobileNav );
				navMobile.prepend( mobileNavCloseButton );

				triggerNavMobile.classList.add( 'open' );
				navMobile.classList.add( 'open' );
				document.body.classList.add( 'nav-mobile-active' );
				overlay.style.display = 'block';
				overlay.addEventListener( 'click', closeMobileNav );
			}
		} );

		const navMobileMenuItems = document.querySelectorAll( '.nav-mobile .menu-item-has-children > a' );

		navMobileMenuItems.forEach( ( item ) => {
			item.addEventListener( 'click', ( e ) => {
				e.preventDefault();

				const accordionHeader = e.target;

				accordionHeader.parentElement.classList.add( 'active' );
				document.querySelectorAll( '.nav-mobile > ul > li:not(.active)' ).forEach( ( secondTierItem ) => {
					secondTierItem.classList.add( 'hidden' );
				} );

				const backButton = document.createElement( 'button' );
				backButton.innerText = 'Back';
				backButton.classList.add( 'go-up' );
				accordionHeader.parentElement.parentElement.prepend( backButton );

				backButton.addEventListener( 'click', ( e ) => {
					e.preventDefault();
					document.querySelectorAll( '.nav-mobile > ul > li.hidden' ).forEach( ( secondTierItem ) => {
						secondTierItem.classList.remove( 'hidden' );
					} );
					document.querySelectorAll( '.nav-mobile > ul > li.active' ).forEach( ( secondTierItem ) => {
						secondTierItem.classList.remove( 'active' );
					} );
					backButton.remove();
				} )
			} );
		} );
	}
}

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', handleMobileNav );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	handleMobileNav();
}

const RMGOverflowXScroll = ( withinElementId = null ) => {
	let scrollable;

	if ( typeof (withinElementId) == 'undefined' ) {
		scrollable = document.querySelectorAll( '.overflow-x-container' );
	} else {
		try {
			const obj = document.getElementById( withinElementId );
			if ( obj !== null ) {
				scrollable = obj.querySelectorAll( '.overflow-x-container' );
			} else {
				scrollable = document.querySelectorAll( '.overflow-x-container' );
			}
		} catch ( error ) {
			scrollable = document.querySelectorAll( '.overflow-x-container' );
		}
	}

	if ( scrollable.length > 0 ) {
		scrollable.forEach( ( el ) => {
			const content = el.querySelector( '.overflow-x-content' );
			if ( ! content ) return;

			const backButton = el.querySelector( '.overflow-x-backward' );
			const forwardButton = el.querySelector( '.overflow-x-forward' );

			const farEdge = content.scrollWidth;

			// debugging: if farEdge and clientWidth are the same value, overflowXScroll is being called before the overflow-x-content box is populated and needs to be called afterwards so it can get the correct width
			// console.log( content.scrollLeft, farEdge, content.clientWidth );

			// scroll to the left each time called
			content.scrollLeft = 0;

			// assuming we have set things up so there is no overlap of a single card on the edge
			// (that is, the cards fill up 100% of the available space)
			// if there is a column gap applied, add that value to the scroll amount
			// this ensures that each click moves the cards so they are aligned full left afterward and the complete card is visible
			let columnGap = 0;
			let columnGapStyle = window.getComputedStyle( content ).getPropertyValue( 'column-gap' );

			// levels of care cards which are unique to this site use the RMG Cards as a block and the overflow-x-content class gets applied to the wrapper rather than the ul containing the cards so we have to drill down one more
			if ( content.classList.contains( 'levels-of-care-cards' ) ) {
				columnGapStyle = window.getComputedStyle( content.querySelector( '.rmg-cards-wrapper' ) ).getPropertyValue( 'column-gap' );
			}

			if ( columnGapStyle ) {
				const columnGapNumber = Number( columnGapStyle.slice( 0, -2 ) );
				if ( ! isNaN( columnGapNumber ) ) {
					columnGap = columnGapNumber;
				}
			}


			if ( el.scrollLeft > 0 && backButton ) {
				backButton.disabled = false;
			} else if ( backButton ) {
				backButton.setAttribute( 'disabled', 'true' );
			}

			// if the container is already scrolled right, or
			// if the content is less than the client width, disable the forward button
			if ( forwardButton && (el.scrollLeft >= farEdge || content.scrollWidth <= el.clientWidth) ) {
				forwardButton.setAttribute( 'disabled', 'true' );
			} else if ( forwardButton ) {
				forwardButton.disabled = false;
			}

			content.addEventListener( 'scroll', () => {
				if ( content.scrollLeft > 0 && backButton ) {
					backButton.disabled = false;
				} else if ( backButton ) {
					backButton.setAttribute( 'disabled', 'true' );
				}

				if ( content.scrollLeft < farEdge - content.clientWidth && forwardButton ) {
					forwardButton.disabled = false;
				} else if ( forwardButton ) {
					forwardButton.setAttribute( 'disabled', 'true' );
				}
			} );

			if ( backButton ) {
				backButton.addEventListener( 'click', function () {
					if ( content.scrollLeft > content.clientWidth ) {
						content.scroll( { left: content.scrollLeft -= (content.clientWidth + columnGap) } );
					} else {
						content.scroll( { left: content.scrollLeft = 0 } );
						backButton.setAttribute( 'disabled', 'true' );
					}
					this.blur();
				} );
			}

			if ( forwardButton ) {
				forwardButton.addEventListener( 'click', function () {
					if ( Math.ceil(content.scrollLeft) < farEdge - content.clientWidth ) {
						content.scroll( { left: content.scrollLeft += (content.clientWidth + columnGap) } );
					} else {
						forwardButton.setAttribute( 'disabled', 'true' );
						content.scroll( { left: content.scrollLeft = farEdge } );
					}
					this.blur();
				} );
			}
		} );
	}
}

window.addEventListener( 'resize', RMGOverflowXScroll );

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet
	document.addEventListener( 'DOMContentLoaded', RMGOverflowXScroll );
} else {
	// `DOMContentLoaded` has already fired
	RMGOverflowXScroll();
}

var RMN_Search_Metrics = {
    id: "",

    Event: function(evt, payload) {
        var newPayload = Object.assign({}, payload, {
            event: evt,
            id: RMN_Search_Metrics.id
        });
        RMN_Search_Metrics.SendEvent(newPayload);
    },

    SendEvent: function(payload) {
        var domain = window.location.hostname;

        var rmgDomainItem = (domain === 'www.treatmentcentersdirectory.com' || domain === 'treatmentcentersdirectory.com')
            ? 'query.treatmentcentersdirectory.com'
            : 'query-staging.treatmentcentersdirectory.com';

        if (typeof rmgESConfig !== 'undefined' && rmgESConfig.esDomain) {
            rmgDomainItem = rmgESConfig.esDomain;
        }

        if (rmgDomainItem) {
            fetch("https://" + rmgDomainItem + "/insights/", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            }).catch(function(err) {
                console.error("Search event tracking failed:", err);
            });
        }
    },

    setup: function() {
        var cookie = RMN_Search_Metrics.getCookie("search_session");
        if (!cookie) {
            RMN_Search_Metrics.id = Math.random().toString(16).slice(2);
            RMN_Search_Metrics.setCookie();
        } else {
            RMN_Search_Metrics.id = cookie;
        }
    },

    setCookie: function() {
        var expires = new Date();
        expires.setTime(expires.getTime() + (30 * 60 * 1000)); // 30 minutes
        document.cookie = "search_session=" + RMN_Search_Metrics.id + "; path=/; expires=" + expires.toUTCString();
    },

    getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name) === 0) {
                return c.substring(name.length);
            }
        }
        return "";
    }
};

RMN_Search_Metrics.setup();
const debounce = ( func, timeout = 300 ) => {
	let timer;
	return ( ...args ) => {
		clearTimeout( timer );
		timer = setTimeout( () => {
			func.apply( this, args );
		}, timeout );
	};
}

const handleSidebarNav = () => {
	// the hook
	const sidebarNav = document.querySelector( '.single-sidebar-as-mobile-nav' );
	if ( ! sidebarNav ) {
		return;
	}

	// the contents
	const sidebarNavContents = document.querySelectorAll( '.rmg-block-rmg-dynamic-table-of-contents-wrapper, .rmg-block-rmg-sidebar-cta-wrapper' );

	// if the window is an appropriate size and we haven't configured the sidebar as a mobile nav yet...
	if ( ( window.innerWidth < 768 || window.innerHeight < 1200 ) && ! document.querySelector( '.sidebar-nav-toggle' ) ) {
		// create an overlay
		const overlay = createOverlay();

		// create a button to toggle the sidebar nav
		const sidebarNavToggle = document.createElement( 'button' );
		sidebarNavToggle.classList.add( 'sidebar-nav-toggle' );
		sidebarNavToggle.innerText = 'Article Sections';

		// move the sidebar nav contents into a wrapper and add that to the header
		const sidebarNavContentsWrapper = document.createElement( 'div' );
		sidebarNavContentsWrapper.classList.add( 'closed' );
		sidebarNavContentsWrapper.classList.add( 'sidebar-nav-contents-wrapper' );

		const toggleSidebarNav = () => {
			sidebarNavContentsWrapper.classList.toggle( 'closed' );
			sidebarNavToggle.classList.toggle( 'closed' );

			if ( document.body.classList.contains( 'nav-mobile-active' ) ) {
				document.body.classList.remove( 'nav-mobile-active' );
				overlay.style.display = 'none';
				overlay.removeEventListener( 'click', toggleSidebarNav );
			} else {
				document.body.classList.add( 'nav-mobile-active' );
				overlay.style.display = 'block';
				overlay.addEventListener( 'click', toggleSidebarNav );
			}
		}

		// give the sidebar nav wrapper a header
		const sidebarnavContentsHeader = document.createElement( 'h2' );
		sidebarnavContentsHeader.innerText = 'Article Sections';
		sidebarNavContentsWrapper.appendChild( sidebarnavContentsHeader );

		// give the sidebar nav wrapper a close button
		const sidebarNavCloseButton = document.createElement( 'button' );
		sidebarNavCloseButton.classList.add( 'nav-close-button' );
		sidebarNavCloseButton.innerText = 'Close';
		sidebarNavCloseButton.addEventListener( 'click', toggleSidebarNav );
		sidebarNavContentsWrapper.appendChild( sidebarNavCloseButton );
		for ( let i = 0; i < sidebarNavContents.length; i++ ) {
			sidebarNavContentsWrapper.appendChild( sidebarNavContents[ i ] );
		}
		sidebarNav.appendChild( sidebarNavToggle );
		document.querySelector( '.site-header' ).appendChild( sidebarNavContentsWrapper );

		sidebarNavContentsWrapper.querySelectorAll( '.rmg-toc a' ).forEach( link => {
			link.addEventListener( 'click', () => {
				toggleSidebarNav();
			} );
		} );

		// open the nav when the button is clicked
		sidebarNavToggle.addEventListener( 'click', toggleSidebarNav );
	} else if ( ( window.innerWidth >= 768 && window.innerHeight >= 1200 ) && document.querySelector( '.sidebar-nav-toggle' ) ) {
		// remove the sidebar nav toggle button
		const sidebarNavToggle = document.querySelector( '.sidebar-nav-toggle' );
		sidebarNavToggle.remove();
		// move the sidebar nav contents back into the sidebar
		const sidebarNavContentsWrapper = document.querySelector( '.sidebar-nav-contents-wrapper' );
		for ( let i = 0; i < sidebarNavContents.length; i++ ) {
			sidebarNav.appendChild( sidebarNavContents[ i ] );
		}
		// cleanup: remove the nav wrapper and overlay
		sidebarNavContentsWrapper.remove();
		getOverlay().remove();
		document.body.classList.remove( 'nav-mobile-active' );
	}
}

const processWindowResizeForFlyoutNav = debounce( () => handleSidebarNav(), 50 );

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', handleSidebarNav );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	handleSidebarNav();
}

window.addEventListener( 'resize', processWindowResizeForFlyoutNav );
// requires debounce function from the single-sidebar-as-mobile-nav file

// define outside of handleTabbedNav to avoid this getting recreated every time handleTabbedNav is called so there is only one instance of the function which will allow us to remove the event listener
const setActiveTabbedNavLink = ( event ) => {
	const sidebarNav = document.querySelector( '.single-sidebar-as-tabbed-nav' );
	sidebarNav.querySelectorAll( '.rmg-toc a.active' ).forEach( ( activeObject ) => {
		activeObject.classList.remove( 'active' );
	} );
	event.target.classList.add( 'active' );
};

const handleTabbedNav = () => {
	// the hook
	const sidebarNav = document.querySelector( '.single-sidebar-as-tabbed-nav' );
	if ( ! sidebarNav ) {
		return;
	}

	// if the window is an appropriate size and we haven't configured the sidebar as a mobile nav yet...
	if ( window.innerWidth < 768 || window.innerHeight < 750 ) {
		sidebarNav.querySelector( '.rmg-block-rmg-dynamic-table-of-contents-wrapper' ).classList.add( 'overflow-x-container' );
		sidebarNav.querySelector( '.rmg-toc' ).classList.add( 'overflow-x-content' );
		sidebarNav.querySelectorAll( '.rmg-toc a' ).forEach( ( link ) => {
			link.addEventListener( 'click', setActiveTabbedNavLink );
		} );
	} else if ( window.innerWidth >= 768 && window.innerHeight >= 750 ) {
		sidebarNav.querySelector( '.rmg-block-rmg-dynamic-table-of-contents-wrapper' ).classList.remove( 'overflow-x-container' );
		sidebarNav.querySelector( '.rmg-toc' ).classList.remove( 'overflow-x-content' );
		sidebarNav.querySelectorAll( '.rmg-toc a' ).forEach( ( link ) => {
			link.removeEventListener( 'click', setActiveTabbedNavLink );
		} );
		sidebarNav.querySelectorAll( '.rmg-toc a.active' ).forEach( function ( activeObject ) {
			activeObject.classList.remove( 'active' );
		} );
	}
}

const processWindowResizeForTabbedNav = debounce( () => handleTabbedNav(), 50 );

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', handleTabbedNav );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	handleTabbedNav();
}

window.addEventListener( 'resize', processWindowResizeForTabbedNav );
const handleNavTabs = () => {
	const tabPanels = document.querySelectorAll( '.nav-wrapper' );

	tabPanels.forEach( ( tabPanel ) => {
		const tabItems = tabPanel.querySelectorAll( '.nav-link' );
		const tabContent = tabPanel.nextElementSibling.querySelectorAll( '.tab-pane' );

		tabItems.forEach( ( tabItem, index ) => {
			tabItem.addEventListener( 'click', ( e ) => {
				e.preventDefault();

				tabItems.forEach( ( item ) => {
					item.classList.remove( 'active' );
				} );

				tabContent.forEach( ( content ) => {
					content.classList.remove( 'active' );
				} );

				tabItem.classList.add( 'active' );
				tabContent[ index ].classList.add( 'active' );
			} );
		} );
	} );

}

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', handleNavTabs );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	handleNavTabs();
}

const whoAnswersModal = () => {
	document.querySelectorAll( [ '.who_answers', '.who-answers' ] ).forEach( ( link ) => {
		link.addEventListener( 'click', function ( e ) {
			e.preventDefault();
			document.querySelector( 'body' ).classList.add( 'modal-open' );
		} );
	} );

	document.querySelector( '.modal-content .close' ).addEventListener( 'click', function ( e ) {
		e.preventDefault();
		document.querySelector( 'body' ).classList.remove( 'modal-open' );
	} );

	document.querySelector( '.modal-wrapper' ).addEventListener( 'click', function ( e ) {
		if ( e.target !== this ) {
			return;
		}
		e.preventDefault();
		document.querySelector( 'body' ).classList.remove( 'modal-open' );

	} );
}

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', whoAnswersModal );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	whoAnswersModal();
}

